<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable no-tabs -->
<template>
  <div class="box">
    <com-header></com-header>
    <div class="containerText" v-if="currentLocale === 'zh'">

      <h2> NEBULA 产品安全政策</h2>
      <h3>I. NEBULA 产品安全政策</h3>
      <p>欢迎来到 NEBULA 产品安全中心！在这里，您将找到关于我们产品安全的基本信息，并了解我们如何致力于为您提供安全可靠的产品体验。</p>
      <p>产品安全标准</p>
      <p>在 NEBULA，我们严格遵守全球安全标准，确保每一款产品都成为您可靠的伙伴。从早期的设计阶段到制造过程，每一步都经过仔细考量，以确保符合国际安全认证。</p>
      <p>常见问题快速指南</p>
      <p>1. 我应该如何维护我的 NEBULA 产品以确保最佳安全性？</p>
      <p>答：请根据我们的用户指南，在合理环境下正确使用产品。</p>
      <p>2. 如果我发现产品存在潜在安全问题，该怎么办？</p>
      <p>答：请立即通过我们的电子邮件联系我们，我们将及时处理您的报告。</p>
      <p>3. 如何查看 NEBULA 产品的安全更新？</p>
      <p>答：您可以随时从 NEBULA 官方网站或 APP 上查找最新的安全信息来更新您的产品。</p>
      <p>感谢您选择 NEBULA，我们期待继续为您提供安全可靠的产品和服务。</p>

      <h3>II. 如何向 NEBULA 报告安全漏洞或问题</h3>
      <p>在 NEBULA，我们高度重视每位用户的安全体验。如果您在使用我们的产品时遇到任何潜在的安全漏洞或问题，我们鼓励您立即向我们报告。您的积极参与是帮助我们提升产品安全性的关键因素。</p>
      <p>报告步骤：</p>
      <p>1. 识别问题： 请提供您所发现安全问题或漏洞的详细描述，包括产品型号和问题发生的具体情况。</p>
      <p>2. 收集信息： 如有可能，请提供重现问题的步骤、影响范围以及任何相关的截图或日志。</p>
      <p>3. 提交报告： 请发送电子邮件至rec@nebulabuds.com，将问题报告给我们的产品安全团队。我们将尽快跟进并就您报告的安全漏洞提供反馈。为保护用户和企业的安全，我们希望您在该漏洞修复前不要公开或传播该漏洞。
      </p>
      <h3>III. NEBULA 安全问题处理流程</h3>
      <p>在收到您报告的安全漏洞或问题后，我们的专业团队将启动以下处理流程：</p>
      <p>1. 初步评估： 我们的安全专家团队将对报告进行初步评估，以确定其有效性和严重性。</p>
      <p>2. 问题调查： 如果报告被确认有效，我们将进行深入调查，以了解问题的确切原因和范围。</p>
      <p>3. 解决方案制定： 根据调查结果，我们的工程团队将制定适当的解决方案，例如软件更新或安全补丁，以解决已识别的漏洞。</p>
      <p>4. 测试与验证： 在实施任何纠正措施之前，我们会进行严格的测试，以确保解决方案的有效性并防止新问题出现。</p>
      <p>5. 实施与通知： 解决方案准备就绪后，我们将通过适当的渠道实施，并通知相关用户更新的详细信息。</p>
      <h3>IV. 我们的承诺</h3>
      <p>响应时间与状态更新</p>
      <p>我们承诺在整个处理过程中保持透明的沟通。我们承诺在 7 天内确认收到您的信息，并在 15 个工作日内做出初步响应。我们将在问题处理过程中向用户同步处理进度，并在官方网站或
        APP及公开渠道同步更新信息，直至问题解决。我们将在漏洞被披露后的 90 天内尽力完成修复工作，但特殊情况下可能需要额外时间。感谢您为提升 NEBULA 产品安全性所做的贡献。</p>
      <p>您的参与至关重要</p>
      <p>我们感谢您的积极参与；您的报告直接有助于改进我们产品的安全性，惠及所有 NEBULA 产品用户。</p>
      <h3>V. 隐私与保密</h3>
      <p>在 NEBULA，我们高度重视您信息的隐私和保密性。当您向我们报告安全漏洞或问题时，我们承诺以最高标准处理您的个人信息。</p>
      <p>1. 隐私保护： 我们保证在处理安全问题报告时，严格保护用户的个人信息。未经您的明确同意，我们不会向第三方透露您的身份或联系信息。</p>
      <p>2. 信息保密： 在问题解决之前，我们将对您报告的安全问题严格保密。采取此措施是为了防止潜在安全威胁的扩散。</p>
      <p>您的信任，我们的责任</p>
      <p>我们理解您对我们的信任基于对您隐私的尊重和保护。我们承诺不遗余力地确保您信息的安全，并感谢您为提升 NEBULA 产品安全性所做的贡献。</p>
      <h3>VI. 法律免责声明</h3>
      <p>感谢您选择 NEBULA 并帮助我们确保产品的安全。我们承诺将感谢每一位保护用户利益并帮助 NEBULA</p>
      <p>
        提升安全质量的用户。然而，我们反对并谴责所有以漏洞测试为借口、利用安全漏洞损害用户利益的黑客行为，包括但不限于利用漏洞窃取用户隐私、入侵业务系统、未经授权获取系统（业务）数据、窃取用户数据、恶意传播漏洞或数据等。请勿在任何公共场所或平台未经许可讨论或披露产品漏洞及具体情况细节。如发生上述任何行为，NEBULA
        有权追究法律责任。</p>
      <p>我们的承诺</p>
      <p>在 NEBULA，我们致力于维持高标准的产品安全，并感谢您的积极参与和支持。我们承诺以最大的尊重和勤勉处理您的报告。</p>
      <p>NEBULA 产品更新公告</p>
      <p>在这里，您可以找到关于我们产品的最新软件更新、安全补丁和功能改进的详细信息。</p>
      <p>请定期查看此页面以获取最新的产品更新，确保您的 NEBULA 产品始终在最安全、最稳定的状态下运行。</p>
      <h3>VII. 致谢：感谢安全贡献者</h3>
      <p>在 NEBULA，我们深刻理解产品安全的重要性，并认识到这是一项需要所有相关方共同努力的任务。我们特别感谢那些协助我们发现和解决产品安全问题的人士。</p>
      <p>您的努力，我们的进步</p>
      <p>每一份报告都直接有助于提高我们的产品安全标准，为所有 NEBULA 用户创造更安全的环境。我们承诺将继续努力，确保您宝贵的建议得到应有的重视和落实。</p>
      <p>携手共建更安全的未来</p>
      <p>感谢您与我们一起努力提升产品安全性。NEBULA 将继续致力于与用户及安全研究社区合作，共同推动安全技术进步。</p>
      <h3>VIII. 联系我们</h3>
      <p>如果您对 NEBULA 产品的安全性有任何疑问，或希望报告安全漏洞，我们鼓励您通过电子邮件 (rec@nebulabuds.com) 与我们联系。</p>
      <p>您的反馈对我们非常宝贵，我们承诺认真对待每一次报告和咨询。</p>
      <h3>IX. NEBULA 产品安全更新保障</h3>
      <p>为确保用户获得持续的安全防护，NEBULA 承诺为我们的产品提供长期的安全更新支持。以下是我们对产品安全更新的保障：</p>
      <p>1. 长期支持： 产品售出后，我们将提供不少于 1 年的维护，在此期间，我们将定期审查并解决任何可能影响产品安全的问题。</p>
      <p>2. 更新频率： NEBULA 将根据产品的具体需求和安全环境的变化，发布定期的安全更新。重大安全威胁将得到优先处理。</p>
      <p>3. 更新通知： 当有新的安全更新可用时，我们将通过适当的渠道（如 APP、电子邮件或我们的官方网站）通知用户。</p>
      <p>4. 若支持期延长，将尽快公布新定义的支持期。</p>
      <p>5. 定义的支持期在发布后不会缩短。</p>
    </div>
    <div class="containerText" v-else>
      <h2>NEBULA Product Security Policy</h2>
      <h3>I. NEBULA Product Security Policy</h3>
      <p>Welcome to the NEBULA Product Security Center! Here you will find basic information about our product security
        and learn how we are committed to providing you with a safe and reliable product experience.</p>
      <p>Product Security Standards</p>
      <p>At NEBULA, we strictly adhere to global safety standards to ensure every product becomes your reliable partner.
        From the early design stages to the manufacturing process, every step is carefully considered to ensure
        compliance with international safety certifications.</p>
      <p>Quick Guide to Common Questions</p>
      <p>1. How should I maintain my NEBULA product to ensure optimal security?</p>
      <p>Answer: Please use the product correctly in a reasonable environment according to our user guide.</p>
      <p>2. What should I do if I discover a potential security issue with the product?</p>
      <p>Answer: Please contact us immediately via our email, and we will promptly address your report.</p>
      <p>3. How can I check for security updates for NEBULA products?</p>
      <p>Answer: You can always find the latest security information from the NEBULA official website or APP to update
        your product.</p>
      <p>Thank you for choosing NEBULA. We look forward to continuing to provide you with safe and reliable products and
        services.</p>

      <h3>II. How to Report Security Vulnerabilities or Issues to NEBULA</h3>
      <p>At NEBULA, we highly value the security experience of every user. If you encounter any potential security
        vulnerabilities or issues while using our products, we encourage you to report them to us immediately. Your
        active participation is a key factor in helping us improve product security.</p>
      <p>Reporting Steps:</p>
      <p>1. Identify the Problem: Please provide a detailed description of the security issue or vulnerability you
        discovered, including the product model and the specific circumstances under which the problem occurred.</p>
      <p>2. Collect Information: If possible, please provide steps to reproduce the issue, the scope of impact, and any
        relevant screenshots or logs.</p>
      <p>3. Submit the Report: Please send an email to rec@nebulabuds.com to report the issue to our product security
        team. We will follow up as soon as possible and provide feedback on the security vulnerability you reported. To
        protect the safety of users and the company, we request that you do not publicly disclose or disseminate the
        vulnerability before it is fixed.</p>
      <h3>III. NEBULA Security Issue Handling Process</h3>
      <p>After receiving your reported security vulnerability or issue, our professional team will initiate the
        following handling process:</p>
      <p>1. Preliminary Assessment: Our team of security experts will conduct an initial assessment of the report to
        determine its validity and severity.</p>
      <p>2. Problem Investigation: If the report is confirmed valid, we will conduct an in-depth investigation to
        understand the exact cause and scope of the problem.</p>
      <p>3. Solution Development: Based on the investigation results, our engineering team will develop an appropriate
        solution, such as a software update or security patch, to address the identified vulnerability.</p>
      <p>4. Testing and Verification: Before implementing any corrective measures, we will conduct rigorous testing to
        ensure the effectiveness of the solution and prevent new issues from arising.</p>
      <p>5. Implementation and Notification: Once the solution is ready, we will implement it through appropriate
        channels and notify relevant users with details of the update.</p>
      <h3>IV. Our Commitment</h3>
      <p>Response Time and Status Updates</p>
      <p>We are committed to maintaining transparent communication throughout the handling process. We commit to
        acknowledging receipt of your information within 7 days and providing an initial response within 15 business
        days. We will keep users informed of the processing progress during the issue handling and will synchronously
        update information on the official website, APP, and public channels until the issue is resolved. We will strive
        to complete the repair work within 90 days of the vulnerability being disclosed, although additional time may be
        required under special circumstances. Thank you for your contribution to enhancing the security of NEBULA
        products.</p>
      <p>Your Participation is Crucial</p>
      <p>We appreciate your active participation; your reports directly help improve the security of our products,
        benefiting all NEBULA product users.</p>
      <h3>V. Privacy and Confidentiality</h3>
      <p>At NEBULA, we place high importance on the privacy and confidentiality of your information. When you report a
        security vulnerability or issue to us, we are committed to handling your personal information with the highest
        standards.</p>
      <p>1. Privacy Protection: We guarantee the strict protection of users' personal information when handling security
        issue reports. We will not disclose your identity or contact information to third parties without your explicit
        consent.</p>
      <p>2. Information Confidentiality: We will maintain strict confidentiality regarding the security issue you
        reported until it is resolved. This measure is taken to prevent the spread of potential security threats.</p>
      <p>Your Trust, Our Responsibility</p>
      <p>We understand that your trust in us is based on respect for and protection of your privacy. We are committed to
        sparing no effort in ensuring the security of your information and thank you for your contribution to enhancing
        the security of NEBULA products.</p>
      <h3>VI. Legal Disclaimer</h3>
      <p>Thank you for choosing NEBULA and helping us ensure the security of our products. We are committed to thanking
        every user who protects user interests and helps NEBULA improve security quality.</p>
      <p>However, we oppose and condemn all hacking activities that use security vulnerabilities under the pretext of
        vulnerability testing to harm user interests, including but not limited to: using vulnerabilities to steal user
        privacy, infiltrating business systems, obtaining system (business) data without authorization, stealing user
        data, maliciously disseminating vulnerabilities or data, etc. Please do not discuss or disclose product
        vulnerabilities and specific details in any public place or platform without permission. If any of the above
        behaviors occur, NEBULA reserves the right to pursue legal liability.</p>
      <p>Our Commitment</p>
      <p>At NEBULA, we are committed to maintaining high standards of product security and appreciate your active
        participation and support. We promise to handle your reports with the utmost respect and diligence.</p>
      <p>NEBULA Product Update Announcements</p>
      <p>Here you can find detailed information about the latest software updates, security patches, and feature
        improvements for our products.</p>
      <p>Please check this page regularly for the latest product updates to ensure your NEBULA product is always
        operating in the safest and most stable state.</p>
      <h3>VII. Acknowledgments: Thanks to Security Contributors</h3>
      <p>At NEBULA, we deeply understand the importance of product security and recognize that it is a task requiring
        the joint efforts of all relevant parties. We especially thank those who assist us in discovering and resolving
        product security issues.</p>
      <p>Your Effort, Our Progress</p>
      <p>Every report directly contributes to improving our product security standards, creating a safer environment for
        all NEBULA users. We are committed to continuing our efforts to ensure your valuable suggestions receive the
        attention and implementation they deserve.</p>
      <p>Working Together for a Safer Future</p>
      <p>Thank you for working with us to enhance product security. NEBULA will continue to commit to collaborating with
        users and the security research community to jointly advance security technology.</p>
      <h3>VIII. Contact Us</h3>
      <p>If you have any questions about the security of NEBULA products or wish to report a security vulnerability, we
        encourage you to contact us via email (rec@nebulabuds.com).</p>
      <p>Your feedback is very valuable to us, and we promise to take every report and inquiry seriously.</p>
      <h3>IX. NEBULA Product Security Update Guarantee</h3>
      <p>To ensure users receive continuous security protection, NEBULA is committed to providing long-term security
        update support for our products. The following is our guarantee for product security updates:</p>
      <p>1. Long-term Support: After the product is sold, we will provide no less than 1 year of maintenance. During
        this period, we will regularly review and resolve any issues that may affect product security.</p>
      <p>2. Update Frequency: NEBULA will release regular security updates based on the specific needs of the product
        and changes in the security environment. Major security threats will be prioritized.</p>
      <p>3. Update Notification: When a new security update is available, we will notify users through appropriate
        channels (such as the APP, email, or our official website).</p>
      <p>4. If the support period is extended, the newly defined support period will be announced as soon as possible.
      </p>
      <p>5. The defined support period will not be shortened after publication.</p>
    </div>
  </div>
</template>

<script>
import comHeader from '@/components/header.vue'
// import comFotter from '@/components/fotter.vue'
export default {
  components: { comHeader },
  data () {
    return {
      isBtnShow: false,
      copyText: '',
      copied: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  mounted () {
    // 确保DOM完全渲染后初始化
    this.copyText = this.$route.params.id
    if (!this.$route.params.id) {
      this.isBtnShow = true
    }
  },
  methods: {
    downloadShow () {
      if (!this.isBtnShow) this.isBtnShow = true
    },
    downloadHide () {
      if (this.isBtnShow) this.isBtnShow = false
    },
    async handleCopy () {
      try {
        // 尝试使用现代 Clipboard API
        await navigator.clipboard.writeText(this.copyText)
        this.showCopiedFeedback()
      } catch (err) {
        // 降级到传统方法
        this.fallbackCopy()
      }
    },
    fallbackCopy () {
      const textarea = document.createElement('textarea')
      textarea.value = this.copyText
      textarea.style.position = 'fixed' // 避免滚动到页面底部
      document.body.appendChild(textarea)
      textarea.select()

      try {
        document.execCommand('copy')
        this.showCopiedFeedback()
      } catch (err) {
        console.error('复制失败:', err)
        alert('复制失败，请手动选择文本并复制')
      }

      document.body.removeChild(textarea)
    },
    showCopiedFeedback () {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 5000)
    }
  }
}
</script>

<style scoped>
.containerText {
  max-width: 1400px;
  margin: 100px auto;
  padding: 10px 5%;
}

h3 {
  padding: 10px;
  font-weight: bold;
}

p {
  text-indent: 2em;
  padding: 5px;
  font-size: 16px;
  line-height: 25px;
}
</style>
